document.addEventListener('alpine:init', () => {
  Alpine.data('trouser', (collective) => ({
    families: [],
    selectedFamily: null,
    selectedProduct: null,
    imageDirections: ['front', 'left', 'right', 'back'],
    images: [],
    animationDuration: 600,
    animationDelay: 100,
    imagesState: 'initial',
    filtered: false,

    init() {
      this.families = JSON.parse(document.querySelector(`#product-collective-${collective}`).textContent);
      this.selectedFamily = this.families[0];
      this.selectedProduct = this.selectedFamily.products[0];

      this.images = this.imageDirections.map((direction) => {
        const rx = new RegExp(`\\b${direction.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
        const match = this.selectedProduct.media.find((m) => rx.test(m?.alt || ''));
        return match?.src ?? null; // optional fallback
      });

      this.watchFilters();
    },

    changeMaterial(material) {
      this.selectedFamily = this.families.find((family) => family.material === material);
      this.selectSwatch(this.selectedFamily.products[0]);
    },

    watchFilters() {
      this.$watch(
        () => Alpine.store('trouser_filters').trouser_shapes,
        async (val) => {
          const isFiltering = !Object.values(val).every((i) => i === false);
          const selectedTrouserShape = this.selectedProduct.trouser_shape[0];

          this.filtered = !val[selectedTrouserShape];

          if (!isFiltering) {
            this.filtered = false;
          }
        }
      );
    },

    selectSwatch(product) {
      if (this.selectedProduct === product) return;
      this.selectedProduct = product;
      this.imagesState = 'fade-out-in';

      this.imageDirections.forEach((direction, index) => {
        setTimeout(() => {
          this.images[index] = product.media.find((media) => media.alt?.toLowerCase().includes(direction))?.src;
        }, this.animationDuration / 3 + this.animationDelay * index);
      });

      setTimeout(() => {
        this.imagesState = 'initial';
      }, this.animationDuration + this.animationDelay * this.imageDirections.length);
    },
  }));
});
